export const ONLINE_TRANSACTIONS_QUERY = `
  query OnlineTransactionsQuery($page: ID!, $q: String, $numberPerPage: ID, $states: [OnlineTransactionStateEnum!], $orderBy: OnlineTransactionOrderByInput) {
    onlineTransactions(page: $page, q: $q, numberPerPage: $numberPerPage, states: $states, orderBy: $orderBy) {
      count
      errors{
        description
      }
      results{
        id
        customer {
          id
          fullname
          petraId
          ssnitNumber
        }
        customerSubscription {
          id
          product {
              id
              name
          }
        }
        transactionType
        provider
        mode
        priceDate
        createdAt
        completedAt
        totalAmount
        status
        taTransactionStatus
      }
    }
  }
`;

export const GLOBAL_SEARCH_ONLINE_TRANSACTIONS = `
  query GlobalSearchOnlineTransactions($page: ID!, $q: String, $numberPerPage: ID) {
    onlineTransactions(page: $page, q: $q, numberPerPage: $numberPerPage) {
      count
      errors{
        description
      }
      results{
        id
        totalAmount
        customer {
          id
          fullname
        }
        customerSubscription {
          id
          product {
              id
              name
          }
        }
      }
    }
  }
`;

export const GET_ONLINE_TRANSACTION = `
  query GetOnlineTransaction($id:ID!) {
    customerTransaction(id: $id ){
        id
        transactionType
        provider
        mode
        priceDate
        completedAt
        totalAmount
        initialRedemptionAmount
        correctInfoDate
        platformFee
        canTransitionToNextStates
        status
        source
        token
        engine
        externalId
        redemptionPreference
        riskBreakdown
        dealProcessed
        deal {
          clientPetraid
          contributions
          createdAt
          customerPetraid
          dealDescription
          dealType
          id
          notificationProcessedAt
          priceDate
          relatedPaymentId
          relatedScheduleId
          shareClass
          shareClassId
          status
          taId
          totalAmount
          totalUnits
          transactionId
          transactionType
          updatedAt
        }
        allocationAmountBreakdown
        notifierRecords {
          id
          notificationType
          status
          message
          recipient
          reference
          createdAt
          updatedAt
          customer {
            id
            petraId
          }
          company {
            id
            petraId
          }
        }
        idType {
          name
        }
        idNumber
        contactInformation
        exitDate
        lienAmount
        employmentDate
        vestingPercentage
        redemptionRequestPurpose {
          name
        }
        redemptionRequestSubPurpose {
          redemptionRequestSubPurposeItem{
            name
          }
        }
        redemptionValue
        redemptionType
        payoutAccount {
          id
          name
          accountNumber
          accountType
          isPayoutAccountVerified
          bankBranch {
            id
            name
            sortCode
            financialInstitution {
              id
              name
            }
          }
        }
        redemptionRequestAttachments{
          id
          attachment{
            id
            name
            url
          }
        }
        subCategory {
          name
        }
        customerTransactionsReasons{
          comment
          customerTransactionStatus
          date
          id
          amount
          reason {
            reasonDescription
          }
        }
        postTaxAmount
        preTaxAmount
        netAmount
        withholdingTax
        withholdingTaxConfirmed
        statusReason
        createdAt
        description
        taTransactionStatus
        reasonComments
        customerTransactionNotes{
          id
          createdAt
          updatedAt
          note{
            createdAt
            description
            id
            updatedAt
            user{
              id
              name
            }
          }
        }
        customer {
          id
          fullname
          petraId
          ssnitNumber
          dateOfBirth
        }
        company {
            id
            name
            petraId
        }
        customerSubscription {
          id
          product {
              id
              name
          }
          productDuration
          customerLiens {
            id
            currentAmount
            totalAmount
            loanPaid
            employeePreTax
            employeePostTax
            employerPreTax
            employerPostTax
            startDate
            endDate
            provider
          }
        }
    }
  }
`;

export const GET_TRANSACTION_CHANGE_LOGS = `
query CustomerTransactionChangeLogs($customerTransactionId: ID!) {
  customerTransactionChangeLogs(customerTransactionId: $customerTransactionId) {
    auditItem
    createdAt
    action
    newValue
    oldValue
    user
    comment
  }
}
`;

export const ASSIGN_NOTE_TO_CUSTOMER_TRANSACTION = `
  mutation AssignNoteToCustomerTransaction($noteId: ID!, $customerTransactionId: ID!)  {
    assignNoteToCustomerTransaction(noteId: $noteId, customerTransactionId: $customerTransactionId){
      customerTransactionNote{
        id
        createdAt
        updatedAt
        note{
          id
          description
          createdAt
          updatedAt
          user{
            id
            name
          }
        }
    }
    errors{
      description
      property
    }
  }
}
`;

export const ASSIGN_ATTACHMENT_TO_CUSTOMER_TRANSACTION = `
  mutation AssignAttachmentsToCustomerTransaction($attachmentIds: [ID!]!, $customerTransactionId: ID!) {
    assignAttachmentsToCustomerTransaction(attachmentIds: $attachmentIds, customerTransactionId: $customerTransactionId) {
      customerTransaction {
        id
        redemptionRequestAttachments {
          id
          attachment {
            id
            url
          }
        }
      }

    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_CUSTOMER_TRANSACTION = `
  mutation unassignAttachmentFromCustomerTransaction($id: ID!) {
    unassignAttachmentFromCustomerTransaction(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const MOVE_CUSTOMER_TRANSACTION_TO_STATE = `
 mutation MoveCustomerTransactionToState($customerTransactionId: ID!, $redemptionRequestReasonId: ID, $comment: String, $state: String!, $date: ISO8601DateTime, $amount: Float){
   moveCustomerTransactionToState(customerTransactionId: $customerTransactionId, redemptionRequestReasonId: $redemptionRequestReasonId, comment: $comment, state: $state, date: $date, amount: $amount) {
      customerTransaction {
        id
      }
      errors{
        description
        property
      }
    }
  }
`;

export const BULK_MOVE_CUSTOMER_TRANSACTION_TO_ISSUED = `
  mutation BulkMoveCustomerTransactionToIssued{
    bulkMoveCustomerTransactionToIssued{
      response
      errors {
        property
        description
      }
    }
  }
`;

export const BULK_UPDATE_CUSTOMER_TRANSACTION_ALLOCATION_AMOUNT = `
  mutation BulkUpdateCustomerTransactionAllocationAmount{
    bulkUpdateCustomerTransactionAllocationAmount {
      response
      errors {
        property
        description
      }
    }
  }
`;
export const GET_TRANSACTION_NOTIFIER_RECORDS_QUERY = `
query GetCustomerTransaction($id: ID!) {
  customerTransaction(id: $id) {
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id
        petraId
      }
      company {
        id
        petraId
      }
    }
  }
}
`;

export const UPDATE_CUSTOMER_TRANSACTION_ALLOCATION_AMOUNT = `
  mutation UpdateCustomerTransactionAllocationAmounts($customerTransactionId: ID!)  {
    updateCustomerTransactionAllocationAmounts(customerTransactionId: $customerTransactionId){
      customerTransaction {
        id
      }
      errors{
        description
        property
      }
    }
  }
`;

export const GET_ONLINE_TRANSACTION_SORT_FIELDS = `
  {
    __type(name: "OnlineTransactionSortFieldEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;

export const GET_ONLINE_TRANSACTION_STATE_ENUM = `
  {
    __type(name: "OnlineTransactionStateEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;
